@if (!collapsed()) {
  <app-button
    (clicked)="openDialog(nameDialog, $event)"
    (keydown.enter)="openDialog(nameDialog, $event)"
    [dataTestId]="'button_createroom'"
    class="custom-btn"
    text="Neuen Chat starten">
    <mat-icon svgIcon="plus-icon"></mat-icon>
  </app-button>
} @else {
  <app-button
    (clicked)="openDialog(nameDialog, $event)"
    (keydown.enter)="openDialog(nameDialog, $event)"
    [dataTestId]="'button_createroom'"
    class="custom-btn"
    tooltip="Neuen Raum erstellen"
    customWidth="5rem"
    tooltipPosition="right">
    <mat-icon svgIcon="plus-icon"></mat-icon>
  </app-button>
}

<ng-template #nameDialog class="dialog-container">
  <div class="header-container">
    <h1 class="header">Chat erstellen</h1>
    <h2 class="sub-header">Bitte geben Sie einen eindeutigen Chatnamen an.</h2>
  </div>
  <form [formGroup]="createForm" class="dialog-form" [attr.data-testid]="testIds.formCreateroom">
    <mat-form-field class="dropdown-privacy" [attr.data-testid]="testIds.fieldPrivacyDropdown">
      <mat-select [attr.data-testid]="testIds.privacyRoomSelect" formControlName="visibility">
        <mat-option [value]="false" [attr.data-testid]="testIds.privateOption"
          >Privat (Einladung erforderlich)</mat-option
        >
        <mat-option [value]="true" [attr.data-testid]="testIds.publicOption">Öffentlich</mat-option>
      </mat-select>
    </mat-form-field>
    @if (isV2RoomEnabled) {
      <div class="room-type-toggle">
        <mat-slide-toggle formControlName="roomType" [attr.data-testid]="testIds.toggleRoomtype">
          Raumtyp v2
        </mat-slide-toggle>
      </div>
    }
    <mat-form-field class="input-container" data-testid="field_name">
      <input
        (keydown.enter)="createForm.valid ? openDialog(inviteDialog) : ''"
        [attr.data-testid]="testIds.fieldNameInput"
        formControlName="name"
        matInput
        placeholder="Chatname" />
      <mat-icon class="icon" matSuffix matTooltip="Der Name des Chats" svgIcon="info"></mat-icon>
      @if (createForm.controls.name.errors?.['required']) {
        <mat-error class="error-message"> Der Name des Chats ist eine Pflichtfeld</mat-error>
      }
      @if (createForm.controls.name.errors?.['pattern']) {
        <mat-error class="error-message">
          Der Name enthält unzulässige Sonderzeichen. Erlaubt sind Zahlen, Buchstaben und Leerzeichen
        </mat-error>
      }
      @if (createForm.controls.name.errors?.['trimmedMinLength']) {
        <mat-error class="error-message">{{ createForm.controls.name.errors?.['trimmedMinLength'] }}</mat-error>
      }
    </mat-form-field>
    @if (createForm.get('visibility')?.value === true) {
      <mat-form-field class="input-container" [attr.data-testid]="testIds.fieldAlias">
        <input
          (keydown.enter)="createForm.valid ? openDialog(inviteDialog) : ''"
          [attr.data-testid]="testIds.fieldAliasInput"
          formControlName="alias"
          matInput
          placeholder="Alias" />
        <mat-icon class="icon" matSuffix matTooltip="Der Alias des Chats" svgIcon="info"></mat-icon>
        @if (createForm.controls.alias.errors?.['pattern']) {
          <mat-error class="error-message"> Der Alias des Raumes darf nur Zahlen und Buchstaben enthalten.</mat-error>
        }
        @if (createForm.controls.alias.errors?.['minlength']) {
          <mat-error class="error-message"> Der Alias des Raumes muss mindestens 2 Zeichen enthalten.</mat-error>
        }
      </mat-form-field>
    }
    <mat-form-field class="description" [attr.data-testid]="testIds.fieldTopic">
      <textarea
        cdkAutosizeMaxRows="15"
        cdkAutosizeMinRows="5"
        cdkTextareaAutosize
        [attr.data-testid]="testIds.fieldTopicInput"
        formControlName="topic"
        matInput
        placeholder="Chatbeschreibung (optional)"></textarea>
    </mat-form-field>
    <div class="button-container">
      <app-button (clicked)="resetForm()" text="Abbrechen" [dataTestId]="testIds.buttonCancel" />
      <app-button
        (clicked)="openDialog(inviteDialog, $event)"
        [isPrimary]="true"
        matDialogClose
        [dataTestId]="testIds.buttonContinue"
        [isDisabled]="createForm.invalid"
        text="Weiter" />
    </div>
  </form>
</ng-template>

<ng-template #inviteDialog class="invite-dialog-container">
  <app-base-invite
    [roomName]="createForm.value.name"
    [isCreateRoomDialog]="true"
    (resetClick)="resetForm()"
    (backClick)="openDialog(nameDialog)"
    (confirmClick)="createRoom($event)" />
</ng-template>
